import { render, staticRenderFns } from "./materialDialogPartner.vue?vue&type=template&id=46fe8913&scoped=true"
import script from "./materialDialogPartner.vue?vue&type=script&lang=js"
export * from "./materialDialogPartner.vue?vue&type=script&lang=js"
import style0 from "./materialDialogPartner.vue?vue&type=style&index=0&id=46fe8913&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe8913",
  null
  
)

export default component.exports